import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { backendUrl } from 'src/environments/environment';
import { toPromise } from './toPromise';

export interface MarkDefaultResponse {
  location_id: number;
}
export interface ShippingLocation {
  data: { locations: Array<Location> };
  country: string;
  province: string;
  town: string;
  street: string;
  house_no: string;
  building: string;
  pincode: string;
  id: number;
  area: string;
}

export interface Location {
  country: string;
  province: string;
  town: string;
  street: string;
  house_no: string;
  building: string;
  pincode: string;
  id: number;
  area: string;
}

@Injectable({
  providedIn: 'root',
})
export class ShippingLocationStore {
  defaultLocation: BehaviorSubject<boolean> = new BehaviorSubject(false);

  token: String = localStorage.getItem('authToken') || null;
  constructor(private httpClient: HttpClient) {}

  async getLocation(): Promise<ShippingLocation> {
    const url = `${backendUrl}location`;
    const token = localStorage.getItem('authToken');
    return toPromise(
      this.httpClient.get<ShippingLocation>(url, {
        headers: new HttpHeaders({
          Authorization: `Bearer ${token}`,
        }),
      })
    );
  }
  async getLocationById(id: number): Promise<ShippingLocation> {
    const url = `${backendUrl}location/${id}`;
    const token = localStorage.getItem('authToken');
    return toPromise(
      this.httpClient.get<ShippingLocation>(url, {
        headers: new HttpHeaders({
          Authorization: `Bearer ${token}`,
        }),
      })
    );
  }
  async deleteLocation(id: number = null): Promise<ShippingLocation> {
    const url = `${backendUrl}location/${id}`;
    const token = localStorage.getItem('authToken');
    return toPromise(
      this.httpClient.delete<ShippingLocation>(url, {
        headers: new HttpHeaders({
          Authorization: `Bearer ${token}`,
        }),
      })
    );
  }
  async makeDefault(data: MarkDefaultResponse): Promise<void> {
    const url = `${backendUrl}set-default-location`;
    const token = localStorage.getItem('authToken');
    return toPromise(
      this.httpClient.post<void>(url, data, {
        headers: new HttpHeaders({
          Authorization: `Bearer ${token}`,
        }),
      })
    );
  }
}
